import useModal from '@/hooks/useModal/useModal';
import ModalContent from '@uikit/components/Modal/ModalContent';
import ContentsToReact from '../ContentsToReact/ContentsToReact';
import ModalPortal from '../ModalPortal/ModalPortal';
import { GenericModalProps } from './interfaces';

const GenericModals = ({ modals, modalComponent, cmsComponents }: GenericModalProps) => {
  const { isVisibleRearLayer, closeModal } = useModal();

  return (
    <>
      {modals?.map(
        (modal) =>
          modal && (
            <ModalPortal
              id={modal.id}
              key={modal.id}
              onClose={closeModal}
              mainLayerVisible={!isVisibleRearLayer}
              modalComponent={modalComponent}
              rearLayer={
                modal.rearLayer && (
                  <ModalContent background="none" width={modal.props.width}>
                    <ContentsToReact
                      contents={modal.rearLayer}
                      cmsComponents={cmsComponents}
                    />
                  </ModalContent>
                )
              }
            >
              <ModalContent width={modal.props.width}>
                <ContentsToReact
                  contents={modal.contents}
                  cmsComponents={cmsComponents}
                />
              </ModalContent>
            </ModalPortal>
          )
      )}
    </>
  );
};

export default GenericModals;
